/**
 * Simple infobox displaying text with closed state support.
 *
 * @unstable
 */

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, inject } from '@angular/core';

import { StatesData } from '@shared/models/prefs.model';

import { PrefsManager } from '@shared/services/prefs-manager.service';

@Component({
  selector: 'zef-infobox',
  templateUrl: './infobox.component.html',
  styleUrls: ['./infobox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class Infobox implements OnInit, OnDestroy {
  private pm = inject(PrefsManager);
  readonly cdRef = inject(ChangeDetectorRef);

  @Input() id = '';

  public show = false;

  private infoTexts: any = {};

  private statesSub: any = null;

  ngOnInit() {
    if (!this.id) {
      this.show = true;
    } else {
      this.statesSub = this.pm.loadStatesData().subscribe((states: StatesData | null) => {
        this.infoTexts = states ? states.infotexts || {} : {};
        if (!this.infoTexts[this.id]) {
          this.show = true;
          this.cdRef.detectChanges();
        } else if (this.statesSub) {
          this.statesSub.unsubscribe();
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.statesSub) {
      this.statesSub.unsubscribe();
    }
  }

  public onCloseAndSave() {
    this.show = false;

    if (this.id) {
      if (this.statesSub) {
        this.statesSub.unsubscribe();
      }

      this.infoTexts[this.id] = true;

      this.pm.updateStatesData({ infotexts: this.infoTexts });
    }

    this.cdRef.detectChanges();
  }
}
